// contexts/ConfigTEFContext.js
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchData, postData, putData, deleteData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';

const ConfigTEFContext = createContext();

export const useConfigTEF = () => useContext(ConfigTEFContext);

export const ConfigTEFProvider = ({ children }) => {
    const [configTEFList, setConfigTEFList] = useState([]);
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();

    const fetchConfigTEF = useCallback(async () => {
        try {
            const result = await fetchData('/ConfigTEF');
            setConfigTEFList(result);
            console.log('render fetch TEF');
            
        } catch (error) {
            console.error("Erro ao buscar configurações de TEF:", error);
            showMessage(`Erro ao buscar configurações de TEF: ${error?.message || error}`, 'danger');
        }
    }, [showMessage]); // Dependência de fetchConfigTEF

    useEffect(() => {
        fetchConfigTEF();
    }, [fetchConfigTEF]); // fetchConfigTEF como dependência

    const addConfigTEF = async (configTEF) => {
        try {
            const result = await postData('/ConfigTEF', configTEF);
            setConfigTEFList([...configTEFList, result]);
            showAlert('Configuração de TEF adicionada com sucesso!');
        } catch (error) {
            console.error("Erro ao adicionar configuração de TEF:", error);
            showMessage(`Erro ao adicionar configuração de TEF: ${error?.message || error}`, 'danger');
        }
    };

    const updateConfigTEF = async (configTEF) => {
        try {
            const result = await putData('/ConfigTEF', configTEF);
            setConfigTEFList((configTEFList) =>
                configTEFList.map((c) => (c.id === result.id ? result : c))
            );
            showAlert('Configuração de TEF alterada com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar configuração de TEF:", error);
            showMessage(`Erro ao atualizar configuração de TEF: ${error?.message || error}`, 'danger');
        }
    };

    const deleteConfigTEF = async (id) => {
        try {
            await deleteData('/ConfigTEF', { configTEFId: id });
            setConfigTEFList(configTEFList.filter(c => c.id !== id));
            showAlert('Configuração de TEF excluída com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir configuração de TEF:", error);
            showMessage(`Erro ao excluir configuração de TEF: ${error?.message || error}`, 'danger');
        }
    };

    return (
        <ConfigTEFContext.Provider value={{ configTEFList, addConfigTEF, updateConfigTEF, deleteConfigTEF }}>
            {children}
        </ConfigTEFContext.Provider>
    );
};